export var ProductType;
(function (ProductType) {
    ProductType["DIGITAL"] = "digital";
    ProductType["PHYSICAL"] = "physical";
    ProductType["SERVICE"] = "service";
    ProductType["GIFT_CARD"] = "gift_card";
    ProductType["UNRECOGNISED"] = "unrecognised";
})(ProductType || (ProductType = {}));
export var ProductInventoryStatus;
(function (ProductInventoryStatus) {
    ProductInventoryStatus["OUT_OF_STOCK"] = "out_of_stock";
    ProductInventoryStatus["IN_STOCK"] = "in_stock";
})(ProductInventoryStatus || (ProductInventoryStatus = {}));
export var IProductPreOrderAvailability;
(function (IProductPreOrderAvailability) {
    IProductPreOrderAvailability["ALL_VARIANTS"] = "all_variants";
    IProductPreOrderAvailability["NO_VARIANTS"] = "no_variants";
    IProductPreOrderAvailability["SOME_VARIANTS"] = "some_variants";
})(IProductPreOrderAvailability || (IProductPreOrderAvailability = {}));
export var MediaFrameMediaType;
(function (MediaFrameMediaType) {
    MediaFrameMediaType["SECURE_PICTURE"] = "secure_picture";
    MediaFrameMediaType["SECURE_VIDEO"] = "secure_video";
    MediaFrameMediaType["SECURE_DOCUMENT"] = "secure_document";
    MediaFrameMediaType["SECURE_MUSIC"] = "secure_music";
    MediaFrameMediaType["SECURE_ARCHIVE"] = "secure_archive";
})(MediaFrameMediaType || (MediaFrameMediaType = {}));
//# sourceMappingURL=product.js.map